import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=2fef8b6e&scoped=true"
import script from "./CreateClient.vue?vue&type=script&lang=js"
export * from "./CreateClient.vue?vue&type=script&lang=js"
import style0 from "./CreateClient.vue?vue&type=style&index=0&id=2fef8b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef8b6e",
  null
  
)

export default component.exports